// Matches the slugs rehype-slug generates for headings, so the
// table of contents links line up with the rendered <h2 id="...">.
export const slugify = (s) =>
  s
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-');

export const formatDate = (iso, long = false) =>
  new Date(iso).toLocaleDateString('en-US', {
    year: 'numeric',
    month: long ? 'long' : 'short',
    day: 'numeric',
  });

// Pull the "## " headings out of a markdown string for the TOC.
export const extractHeadings = (markdown) =>
  markdown
    .split('\n')
    .filter((line) => line.startsWith('## '))
    .map((line) => {
      const text = line.replace(/^##\s+/, '').trim();
      return { text, id: slugify(text) };
    });
